import React from 'react';
import { useSelector } from 'react-redux';
import { Retry } from '@components/common';
import { TableWrapper, WidgetActions } from './styled';
import useErrorDimension from '../hooks/useErrorDimension';
import { TABLE_HEIGHT_MAPPING } from '../header/Resize';
import Search from './Search';
import { useAtomValue } from 'jotai';
import { heightAtom, unitAtom } from '../atoms';
import Table from '@components/common/Table';
import useGrid from '../hooks/useGrid';
import { tableCompareEnabledSelector } from '@store/trends/birdChart/selectors';

function ErrorDimensionTable({ dimension, updateGrid }) {
  const unit = useAtomValue(unitAtom);
  const height = useAtomValue(heightAtom);
  const isTableCompareEnabled = useSelector(tableCompareEnabledSelector);

  const {
    data,
    totals,
    columns,
    isFetching,
    isError,
    isEmpty,
    refetch,
    sortBy,
    onColumnSort,
    onSearch,
    searchText,
    pctShareMaxValues,
  } = useErrorDimension({ dimension, unit });

  useGrid({ data, isError, isFetching, updateGrid });

  return (
    <>
      <WidgetActions>
        <Search onSearch={onSearch} text={searchText} />
      </WidgetActions>
      <TableWrapper style={{ height: TABLE_HEIGHT_MAPPING[height] }}>
        <Retry
          fetchData={refetch}
          isLoading={isFetching}
          showError={isError}
          // LoadingLayer={TableSkeleton}
          isEmpty={isEmpty}
          progress={true}
        >
          <Table
            data={data}
            frozenData={[totals]}
            columns={columns}
            headerHeight={35}
            rowHeight={35}
            rowKey={'value'}
            sortBy={sortBy}
            onColumnSort={onColumnSort}
            headerProps={{ pctShareMaxValues, showTrend: isTableCompareEnabled  }}
          />
        </Retry>
      </TableWrapper>
    </>
  );
}

export default ErrorDimensionTable;
